import type { CargaLocalProps } from "./types-carga-local";
import { useCargaLocal } from "./use-carga-local";
import { CargaLocalView } from "./view-carga-local";

export function CargaLocal(props: CargaLocalProps) {
  const vm = useCargaLocal(props);

  return <CargaLocalView {...vm} />;
}

export type * from "./types-carga-local";
